// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MSYu","questions":"styles_questions__To3MX","footer":"styles_footer__SEIem"};